import apiService from 'frontcore/data/api-service/api-service'
import { defineStore } from 'pinia'
import { ref } from 'vue'


type ExperimentalFeatures = {
  DUMMY_FEATURE?: boolean,
}

/**
 * See docs in notion: https://www.notion.so/Experimental-Features-adc8542b1f6b4198a621e7017cb1ecaa
 * Only add or remove Experimental Features in ExperimentalFeatures. Do not change useExperimentalFeaturesStore.
 * DUMMY_FEATURE is simply to avoid an empty type.
 */
const useExperimentalFeaturesStore = defineStore('experimental-features', () => {
  const experimentalFeatures = ref<ExperimentalFeatures>({})

  const fetchExperimentalFeatures = async () => {
    try {
      const response = await apiService
        .buildRequest()
        .withSessionToken()
        .get<ExperimentalFeatures>('configurations/experimental/')
      experimentalFeatures.value = response.data
    } catch {
      experimentalFeatures.value = {}
    }
  }

  return {
    fetchExperimentalFeatures,
    experimentalFeatures,
  }
})

export default useExperimentalFeaturesStore
